"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getListName = getListName;
exports.getMergeLists = getMergeLists;
exports.getMergeMetadata = getMergeMetadata;
exports.getMergeResources = getMergeResources;
exports.getOperationType = getOperationType;
exports.getRequestKey = getRequestKey;
exports.getRequestName = getRequestName;
exports.getRequestProperties = getRequestProperties;
exports.getResourceListByType = getResourceListByType;
exports.getResourceMetadataByType = getResourceMetadataByType;
exports.getResourceType = getResourceType;
exports.getResourcesArray = getResourcesArray;
exports.getResourcesByType = getResourcesByType;
exports.isCreateRequestAction = isCreateRequestAction;
exports.isDeleteRequestAction = isDeleteRequestAction;
exports.isFulfilledAction = isFulfilledAction;
exports.isIdleAction = isIdleAction;
exports.isPendingAction = isPendingAction;
exports.isReadRequestAction = isReadRequestAction;
exports.isRejectedAction = isRejectedAction;
exports.isRequestAction = isRequestAction;
exports.isResourceAction = isResourceAction;
exports.isResourceType = isResourceType;
exports.isUpdateRequestAction = isUpdateRequestAction;
exports.isValidOperationType = isValidOperationType;

var _warning = _interopRequireDefault(require("@flowio/warning"));

var _language = require("./language");

var _constants = require("../constants");

/**
 * @fileoverview
 * This module provides utilities for accessing and introspecting properties
 * found in both resource and request actions.
 */
function isValidOperationType(operationType) {
  return [_constants.operationTypes.CREATE, _constants.operationTypes.READ, _constants.operationTypes.UPDATE, _constants.operationTypes.DELETE].indexOf(operationType) >= 0;
}

function isRequestAction(action) {
  return [_constants.actionTypes.REQUEST_FULFILLED, _constants.actionTypes.REQUEST_IDLE, _constants.actionTypes.REQUEST_PENDING, _constants.actionTypes.REQUEST_REJECTED].indexOf(action.type) >= 0;
}

function isResourceAction(action) {
  return [_constants.actionTypes.UPDATE_RESOURCES, _constants.actionTypes.DELETE_RESOURCES].indexOf(action.type) >= 0;
}

function isPendingAction(action) {
  return action.type === _constants.actionTypes.REQUEST_PENDING;
}

function isFulfilledAction(action) {
  return action.type === _constants.actionTypes.REQUEST_FULFILLED;
}

function isRejectedAction(action) {
  return action.type === _constants.actionTypes.REQUEST_REJECTED;
}

function isIdleAction(action) {
  return action.type === _constants.actionTypes.REQUEST_IDLE;
}
/**
 * Returns operation type for the specified request action.
 * Prints warning when request actions does not include an operation type or
 * the operation type is invalid, if you'd like to prevent warnings from being
 * printed, you may pass `{ silent: true }` as an option.
 * @param {*} action
 * @param {object} [options]
 * @param {boolean} [options.silent = false]
 *
 */


function getOperationType(action) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var operationType = (0, _language.getProperty)(action, ['meta', 'operationType']);

  if ((0, _language.isNil)(operationType)) {
    (0, _warning.default)(options.silent, 'A Redux Resource action of type `%s` was dispatched without an ' + 'operation type. Without an operation type, Redux Resource will not ' + 'be able to update the resource slice of your store. You should check ' + 'your action creators to make sure that they always include a ' + '`meta.operationType` property.', action.type);
  } else if (!isValidOperationType(operationType)) {
    (0, _warning.default)(options.silent, 'A Redux Resource action of type `%s` was dispatched with an invalid ' + 'operation type value. An operation type must be one of the following ' + 'values: `"create"`, `"read"`, `"update"`, or `"delete"`.', action.type);
  }

  return operationType;
}
/**
 * Returns resource type for the specified request action.
 * Prints warning when request action does not include a resource type, if
 * you'd like to prevent warnings from being printed, you may pass
 * `{ silent: true }` as an option.
 * @param {*} action
 * @param {object} [options]
 * @param {boolean} [options.silent = false]
 */


function getResourceType(action) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var resourceType = (0, _language.getProperty)(action, ['meta', 'resourceType']);

  if ((0, _language.isNil)(resourceType)) {
    (0, _warning.default)(options.silent, 'A Redux Resource action of type `%s` was dispatched without a resource ' + 'type. Without a resource type, Redux Resource will not be able to ' + 'update the resource slice of your store. You should check your action ' + 'creators to make sure they always include a `meta.resourceType` ' + 'property.', action.type);
  }

  return resourceType;
}
/**
 * Returns list name for the specified request action.
 * @param {*} action
 */


function getListName(action) {
  return (0, _language.getProperty)(action, ['meta', 'list']);
}
/**
 * Returns request key for the specified request action.
 * @param {*} action
 */


function getRequestKey(action) {
  return (0, _language.getProperty)(action, ['meta', 'requestKey']);
}
/**
 * Returns request name for the specified request action.
 * @param {*} action
 */


function getRequestName(action) {
  return (0, _language.getProperty)(action, ['meta', 'requestName']);
}
/**
 * Returns request properties for the specified request action.
 * @param {*} action
 */


function getRequestProperties(action) {
  return (0, _language.getProperty)(action, ['meta', 'requestProperties']);
}
/**
 * Returns resources for the specified request action.
 * Prints warning when request action does not include a resources array, if
 * you'd like to prevent warnings from being printed, you may pass
 * `{ silent: true }` as an option
 * @param {*} action
 * @param {object} [options]
 * @param {boolean} [options.silent = false]
 */


function getResourcesArray(action) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var resources = (0, _language.getProperty)(action, ['payload', 'resources']) || (0, _language.getProperty)(action, ['meta', 'resources']);

  if ((0, _language.isNil)(resources)) {
    (0, _warning.default)(options.silent, 'A Redux Resource action of type `%s` was dispatched without a resources ' + 'array. Without a resources array, Redux Resource will not be able to ' + 'track which resources were affected by this CRUD operation. You ' + 'should check your action creators to make sure they include a ' + '`payload.resources` property.', action.type);
  } else if (!(0, _language.isArray)(resources)) {
    (0, _warning.default)(options.silent, 'A Redux Resource action of type `%s` was dispatched with a non-array ' + 'resources value. If your backend returned a single object, be sure ' + 'to wrap it inside of an array.', action.type);
  }

  return resources;
}
/**
 * Returns resources matching specified type for the specified resource action.
 * @param {*} action
 */


function getResourcesByType(action, resourceType) {
  return (0, _language.getProperty)(action, ['payload', 'resources', resourceType]);
}
/**
 * Returns resource metadata matching specified type for the specified
 * resource action.
 * @param {*} action
 * @param {string} resourceType
 */


function getResourceMetadataByType(action, resourceType) {
  return (0, _language.getProperty)(action, ['payload', 'metadata', resourceType]);
}
/**
 * Returns resource list matching specified type for the specified
 * resource action.
 * @param {*} action
 * @param {string} resourceType
 */


function getResourceListByType(action, resourceType) {
  return (0, _language.getProperty)(action, ['payload', 'lists', resourceType]);
}
/**
 * Returns whether resources of the specified type should be merged into
 * existing resources. By design, this setting is always true unless indicated
 * otherwise in the specified action.
 * @param {*} action
 * @param {string} [resourceType]
 * @returns {boolean}
 */


function getMergeResources(action, resourceType) {
  var mergeResources = (0, _language.getProperty)(action, ['meta', 'mergeResources']);

  if ((0, _language.isBoolean)(mergeResources)) {
    return mergeResources;
  }

  if ((0, _language.isObject)(mergeResources) && !(0, _language.isNil)(resourceType)) {
    return mergeResources[resourceType];
  }

  return true;
}
/**
 * Returns whether metadata for resources of the specified type should be
 * merged into existing resource metadata. By design, this setting is always
 * true unless indicated otherwise in the specified action.
 * @param {*} action
 * @param {string} [resourceType]
 * @returns {boolean}
 */


function getMergeMetadata(action, resourceType) {
  var mergeMetadata = (0, _language.getProperty)(action, ['meta', 'mergeMetadata']);

  if ((0, _language.isBoolean)(mergeMetadata)) {
    return mergeMetadata;
  }

  if ((0, _language.isObject)(mergeMetadata) && !(0, _language.isNil)(resourceType)) {
    return mergeMetadata[resourceType];
  }

  return true;
}
/**
 * Returns whether resource identifiers of the specified resource type should
 * be merged into existing lists for the specified action. By design, this
 * setting is always true unless indicated otherwise in the specified action.
 * @param {*} action
 * @param {string} [resourceType]
 * @returns {boolean}
 */


function getMergeLists(action, resourceType) {
  var mergeLists = (0, _language.getProperty)(action, ['meta', 'mergeLists']);

  if ((0, _language.isBoolean)(mergeLists)) {
    return mergeLists;
  }

  if ((0, _language.isObject)(mergeLists) && !(0, _language.isNil)(resourceType)) {
    return mergeLists[resourceType];
  }

  return true;
}

function isResourceType(action, resourceType) {
  return getResourceType(action) === resourceType;
}

function isCreateRequestAction(action) {
  return getOperationType(action) === _constants.operationTypes.CREATE;
}

function isReadRequestAction(action) {
  return getOperationType(action) === _constants.operationTypes.READ;
}

function isUpdateRequestAction(action) {
  return getOperationType(action) === _constants.operationTypes.UPDATE;
}

function isDeleteRequestAction(action) {
  return getOperationType(action) === _constants.operationTypes.DELETE;
}